export default "__VITE_ASSET__Dq3KR$A1__"